import { disableBodyScroll } from 'body-scroll-lock'

const ignoreDisableBodyScroll = (target) => {
  disableBodyScroll(target, {
    allowTouchMove: (el) => {
      // Code from: https://www.npmjs.com/package/body-scroll-lock / https://www.npmjs.com/package/body-scroll-lock#more-complex
      while (el && el !== document.body) {
        if (el.getAttribute('body-scroll-lock-ignore') !== null) {
          return true
        }
        el = el.parentElement
      }
    }
  })
}

function preventScroll (event) {
  event.preventDefault()
  event.stopPropagation()
}

// Disable scrolling
function disableScroll () {
  document.addEventListener('wheel', preventScroll, { passive: false })
  document.addEventListener('touchmove', preventScroll, { passive: false })
  document.addEventListener('keydown', preventArrowKeys)
}

// Enable scrolling
function enableScroll () {
  document.removeEventListener('wheel', preventScroll)
  document.removeEventListener('touchmove', preventScroll)
  document.removeEventListener('keydown', preventArrowKeys)
}

function preventArrowKeys (event) {
  const keys = [32, 37, 38, 39, 40] // Space and arrow keys

  if (keys.includes(event.keyCode)) {
    event.preventDefault()
  }
}

export { ignoreDisableBodyScroll, disableScroll, enableScroll }
